class PostTemplate {
	getElement(post) {
		const div = document.createElement('div')
		div.innerHTML = this.getHtml(post)
		return div.firstElementChild
	}
	getHtml(post) {
		// console.log(post) // Odkomentuj jeżeli chcesz sprawdzić dostępnę wartości na widoku

		const image = post.imageLink ? /* html */ `
			<picture>
				<img src="${post.imageLink}" alt="Zdjęcie ${post.title}" title="Zdjęcie do wpisu: ${post.title}" class="blog-img img-responsive">
			</picture>
		` : ''

		return /* html */ `
			<div class="col-12 col-lg-4">
				<div class="blog-item">
					<div class="blog-img-wrapper">
						<a class="" href="${post.link}" title="${post.title}">
							${image}
						</a>
						
					</div>
					<div class="blog-date  events__date">
						${post.published}
					</div>

					<div class="blog-heading events__blog-title">
						<h3>${post.title}</h3>
					</div>

					<p class="blog-readmore events__text">${post.description}</p>

						<a class="link-primary events__btn" title="Czytaj więcej na temat ${post.title}" href="${post.link}">
							czytaj więcej

							<svg xmlns="http://www.w3.org/2000/svg" width="6.653" height="11.281" viewBox="0 0 6.653 11.281"><path id="Path_6851" data-name="Path 6851" d="M9.293,6.713a1.006,1.006,0,0,0,0,1.424l3.92,3.92-3.92,3.92A1.007,1.007,0,0,0,10.717,17.4l4.637-4.637a1.006,1.006,0,0,0,0-1.424L10.717,6.7A1.015,1.015,0,0,0,9.293,6.713Z" transform="translate(-8.997 -6.416)" fill="#0075a6"></path></svg>

						</a>
				
				</div>
			</div>
		`
	}
}

const postTemplate = new PostTemplate()
export {
	PostTemplate,
	postTemplate
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_posts_loader/template/PostTemplate.js